import { render } from "./KonkursetTable.vue?vue&type=template&id=68d01bdf&scoped=true"
import script from "./KonkursetTable.vue?vue&type=script&lang=js"
export * from "./KonkursetTable.vue?vue&type=script&lang=js"

import "./KonkursetTable.vue?vue&type=style&index=0&id=68d01bdf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d01bdf"]])

export default __exports__